export default __webpack_public_path__ + "static/media/cyzzy_page.6b6ab39f.jpg";